// extracted by mini-css-extract-plugin
export default {"data":"SkillItem_data__outtK","title":"SkillItem_title__O7-kY","name":"SkillItem_name__X8BbF","bar":"SkillItem_bar__2wYz1","percentage":"SkillItem_percentage__dBl6Y"};